export interface TawAppState {
  message: string;
}

export const initAppState = {
  message: "Hello"
}
